import React, { PropsWithChildren } from "react";
import { Box } from "@mui/material";

interface PageWrapperProps extends PropsWithChildren {
  index: number;
  spacing: number;
}

const SinglePageWrapper =(
  ({ children, index, spacing }: PageWrapperProps) => (
    <Box
      sx={{
        gap: `${spacing}px`,
        justifyContent: "space-between",
        alignItems: "stretch",
        height: "auto",
        display: "flex",
        flexShrink: 0
      }}
      data-testid={`carousel-single-page_${index}`}
    >
      {children}
    </Box>
  )
);

export default SinglePageWrapper;
